import { render } from "./HandleSettings.vue?vue&type=template&id=7bfd1860"
import script from "./HandleSettings.vue?vue&type=script&lang=js"
export * from "./HandleSettings.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__